import FourOFour from "Pages/private/404";
import GeneralParameter from "Pages/private/parameters/general";
import React from "react";
import { Route, Switch } from "react-router-dom";
import RouteList from "../list";
import PrivateRoute from "../route";

export default function ParameterRoutes() {
  const root = RouteList[0].children.find((f) => f.name === "Parametreler");
  const routeList = root.children || [];
  const path = "/panel/parametreler";

  let routes = [];
  const flattenRoutes = (routePath, list) => {
    list.map((item) => {
      let path = routePath + item.path;

      if (item.children?.length > 0 && !item.layout) {
        flattenRoutes(path, item.children);
      }

      routes.push({ ...item, path: path });
    });
  };

  flattenRoutes(path, routeList);

  return (
    <Switch>
      <Route
        key="home"
        path={`${path}`}
        exact={true}
        render={() => {
          return (
            <p style={{ margin: 20 }}>
              Sol Menüden düzenleyeceğiniz parametre tipini seçerek, işleminize
              başlayabilirsiniz
            </p>
          );
        }}
      />
      {routes.map((item) => (
        <PrivateRoute
          key={item.name}
          path={`${item.path}`}
          authSubject={item.authSubject}
          component={
            <GeneralParameter
              api={item.api}
              title={item.name}
              authSubject={item.authSubject}
              ItemsComponent={item.ItemsComponent}
              columnsExtended={item.columnsExtended}
              editableCode={item.editableCode}
              mode={item.mode || "edit"}
            />
          }
        />
      ))}
      <Route component={FourOFour} />
    </Switch>
  );
}
